import styled from 'styled-components';

const List = styled.ul`
  list-style: none;
  padding: 0;
`;
const Error = styled.div`
  color: #b22222;
  font-weight: bold;
  line-height: 30px;
  padding: 20px 16px 0;
  font-size: 22px;
  text-align: center;
`;

export { List, Error };
